import { render } from "./SiteContactsCard.vue?vue&type=template&id=082531fe&ts=true"
import script from "./SiteContactsCard.ts?vue&type=script&lang=ts"
export * from "./SiteContactsCard.ts?vue&type=script&lang=ts"

import "./SiteContactsCard.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__